import { useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { getAuthenticatedUserProfile } from '../../../api/users';
import { authenticateUser } from '../../../state/slices/user';
import { store } from '../../../state/store';
import { useAppTheme } from '../../../theme/useTheme';
import Loader from '../../common/Loader/Loader';
import './ConsumeToken.css';

const ConsumeToken = () => {
  const { access_token } = useParams();
  const navigate = useNavigate();
  const { mode } = useAppTheme();
  
  const getUserProfile = async () => {
    const { data } = await getAuthenticatedUserProfile();
    if (data !== null) {
      await store.dispatch(authenticateUser(data));
      const redirectPath = sessionStorage.getItem('redirectAfterLogin');
      if (redirectPath) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectPath);
      } else {
        navigate('/pam/dashboard');
      }
    }
  }

  useEffect(() => {
    localStorage.setItem('jwt', access_token);
    getUserProfile();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <div className="consume-token-container" data-theme={mode}>
      <Loader loading={true} bg_papper={false} />
    </div>
  )
}

export default ConsumeToken;
